import {
  FETCH_AUTH,
  FETCH_USER,
  FETCH_POST,
  SET_USER,
  SET_FIRESTORE_USER,
  SET_STRIPE_DATA,
  REMOVE_FIRESTORE_USER,
} from "../config/constant";

export function fetchAuth(isAuth, authType) {
  return {
    type: FETCH_AUTH,
    isAuth,
    authType,
  };
}
export function fetchUser(user = null, users = [], kind = null) {
  return {
    type: FETCH_USER,
    user,
    users,
    kind,
  };
}
export function fetchPost(post = null, posts = [], flag = 0) {
  return {
    type: FETCH_POST,
    post,
    posts,
    flag,
  };
}

export function setFiresotreUser(firestoreUser) {
  return {
    type: SET_FIRESTORE_USER,
    firestoreUser,
  };
}

export function removeFirestoreUser() {
  return {
    type: REMOVE_FIRESTORE_USER,
  };
}

export function setStripeData(stripeData) {
  return {
    type: SET_STRIPE_DATA,
    stripeData,
  };
}
